import React from 'react';
 
export const FormField = ({ 
  id, 
  name, 
  type, 
  label, 
  placeholder, 
  icon, 
  value, 
  onChange,
  required = false 
}) => {
  return (
    <div className="space-y-2 transform transition-all duration-300 group">
      <label
        htmlFor={id}
        className="text-sm font-medium text-gray-300 block group-hover:text-amber-300 transition-colors"
      >
        {label}
      </label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none transition-all group-hover:text-amber-400">
          {icon}
        </div>
        <input
          id={id}
          name={name}
          type={type}
          required={required}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          className="w-full pl-10 pr-3 py-2 rounded-md
                  bg-gray-800/50 border border-gray-700 
                  text-gray-200 placeholder:text-gray-500
                  focus:border-amber-500/50 focus:ring-1 focus:ring-amber-500/30 
                  focus:outline-none
                  transition-all duration-300 form-input-effect"
        />
        
        {/* Animated focus gradient */}
        <div className="absolute inset-x-0 -bottom-0.5 h-0.5 bg-gradient-to-r from-amber-500/0 via-amber-400/70 to-amber-500/0 rounded-full opacity-0 group-hover:opacity-30 transition-opacity animate-shimmer"></div>
      </div>
    </div>
  );
};